<template>
    <div :class="['input-wrapper', 'form-input-radio', 'form-input-radio--'+type, { 'input-wrapper-mb-2x': marginBottomDouble }]">
        <div v-for="(option, index) in options" class="radio-wrapper" :key="index">
            <input v-model="inputValue" :id="name+'-'+option.value" type="radio" :name="name" :value="option.value" />
            <label class="label-static" :for="name+'-'+option.value">{{ option.label }}</label>
        </div>

        <form-input-error v-if="hasError" :error="errors[0]"></form-input-error>
        <form-input-note v-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },

            options: {
                type: Array,
                required: true
            },

            required: {
                type: Boolean,
                required: false,
                default: false
            },

            note: {
                type: String,
                required: false,
                default: null
            },

            marginBottomDouble: {
                type: Boolean,
                required: false,
                default: false
            },

            value: {
                type: String,
                required: false,
                default: null
            },

            errors: {
                type: Array,
                required: false,
                default: null
            },

            type: {
                type: String,
                required: false,
                default: 'default',
                validator: function (value) {
                    return ['default', 'check'].indexOf(value) !== -1
                }
            },
        },

        data() {
            return {
                inputValue: this.value,
                hasError: false
            }
        },

        watch: {
            inputValue(value) {
                if (value.length > 0) {
                    this.hasError = false
                }
            },

            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    } 
                }
            }
        }
    }
</script>
